import script from "./PlaceField.vue?vue&type=script&lang=js"
export * from "./PlaceField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"PlaceField.vue"]])

export default __exports__